const ungroupedData = [{
    stateId: "ACT,Australia",
    stateName: "Australian Capital Territory",
    stateCode: "ACT",
    countryName: "Australia",
},
{
    stateId: "NSW,Australia",
    stateName: "New South Wales",
    stateCode: "NSW",
    countryName: "Australia"
},
{
    stateId: "NT,Australia",
    stateName: "Northern Territory",
    stateCode: "NT",
    countryName: "Australia"
},
{
    stateId: "QLD,Australia",
    stateName: "Queensland",
    stateCode: "QLD",
    countryName: "Australia"
},
{
    stateId: "SA,Australia",
    stateName: "South Australia",
    stateCode: "SA",
    countryName: "Australia"
},
{
    stateId: "TAS,Australia",
    stateName: "Tasmania",
    stateCode: "TAS",
    countryName: "Australia"
},
{
    stateId: "VIC,Australia",
    stateName: "Victoria",
    stateCode: "VIC",
    countryName: "Australia"
},
{
    stateId: "WA,Australia",
    stateName: "Western Australia",
    stateCode: "WA",
    countryName: "Australia"
},
{
    stateId: "AB,Canada",
    stateName: "Alberta",
    stateCode: "AB",
    countryName: "Canada",
},
{
    stateId: "BC,Canada",
    stateName: "British Columbia",
    stateCode: "BC",
    countryName: "Canada",
},
{
    stateId: "MB,Canada",
    stateName: "Manitoba",
    stateCode: "MB",
    countryName: "Canada",
},
{
    stateId: "NB,Canada",
    stateName: "New Brunswick",
    stateCode: "NB",
    countryName: "Canada",
},
{
    stateId: "NL,Canada",
    stateName: "Newfoundland and Labrador",
    stateCode: "NL",
    countryName: "Canada",
},
{
    stateId: "NT,Canada",
    stateName: "Northwest Territories",
    stateCode: "NT",
    countryName: "Canada",
},
{
    stateId: "NS,Canada",
    stateName: "Nova Scotia",
    stateCode: "NS",
    countryName: "Canada",
},
{
    stateId: "NU,Canada",
    stateName: "Nunavut",
    stateCode: "NU",
    countryName: "Canada",
},
{
    stateId: "ON,Canada",
    stateName: "Ontario",
    stateCode: "ON",
    countryName: "Canada",
},
{
    stateId: "QC,Canada",
    stateName: "Quebec",
    stateCode: "QC",
    countryName: "Canada",
},
{
    stateId: "YT,Canada",
    stateName: "Yukon",
    stateCode: "YT",
    countryName: "Canada",
},
{
    stateId: "AK,USA",
    stateName: "Alaska",
    stateCode: "AK",
    countryName: "USA",
},
{
    stateId: "AL,USA",
    stateName: "Alabama",
    stateCode: "AL",
    countryName: "USA",
},
{
    stateId: "AR,USA",
    stateName: "Arkansas",
    stateCode: "AR",
    countryName: "USA",
},
{
    stateId: "AZ,USA",
    stateName: "Arizona",
    stateCode: "AZ",
    countryName: "USA",
},
{
    stateId: "CA,USA",
    stateName: "California",
    stateCode: "CA",
    countryName: "USA",
},
{
    stateId: "CO,USA",
    stateName: "Colorado",
    stateCode: "CO",
    countryName: "USA",
},
{
    stateId: "CT,USA",
    stateName: "Connecticut",
    stateCode: "CT",
    countryName: "USA",
},
{
    stateId: "DC,USA",
    stateName: "District of Columbia",
    stateCode: "DC",
    countryName: "USA",
},
{
    stateId: "DE,USA",
    stateName: "Delaware",
    stateCode: "DE",
    countryName: "USA",
},
{
    stateId: "FL,USA",
    stateName: "Florida",
    stateCode: "FL",
    countryName: "USA",
},
{
    stateId: "GA,USA",
    stateName: "Georgia",
    stateCode: "GA",
    countryName: "USA",
},
{
    stateId: "HI,USA",
    stateName: "Hawaii",
    stateCode: "HI",
    countryName: "USA",
},
{
    stateId: "IA,USA",
    stateName: "Iowa",
    stateCode: "IA",
    countryName: "USA",
},
{
    stateId: "ID,USA",
    stateName: "Idaho",
    stateCode: "ID",
    countryName: "USA",
},
{
    stateId: "IL,USA",
    stateName: "Illinois",
    stateCode: "IL",
    countryName: "USA",
},
{
    stateId: "IN,USA",
    stateName: "Indiana",
    stateCode: "IN",
    countryName: "USA",
},
{
    stateId: "KS,USA",
    stateName: "Kansas",
    stateCode: "KS",
    countryName: "USA",
},
{
    stateId: "KY,USA",
    stateName: "Kentucky",
    stateCode: "KY",
    countryName: "USA",
},
{
    stateId: "LA,USA",
    stateName: "Louisiana",
    stateCode: "LA",
    countryName: "USA",
},
{
    stateId: "MD,USA",
    stateName: "Maryland",
    stateCode: "MD",
    countryName: "USA",
},
{
    stateId: "ME,USA",
    stateName: "Maine",
    stateCode: "ME",
    countryName: "USA",
},
{
    stateId: "MA,USA",
    stateName: "Massachusetts",
    stateCode: "MA",
    countryName: "USA",
},
{
    stateId: "MI,USA",
    stateName: "Michigan",
    stateCode: "MI",
    countryName: "USA",
},
{
    stateId: "MN,USA",
    stateName: "Minnesota",
    stateCode: "MN",
    countryName: "USA",
},
{
    stateId: "MO,USA",
    stateName: "Missouri",
    stateCode: "MO",
    countryName: "USA",
},
{
    stateId: "MS,USA",
    stateName: "Mississippi",
    stateCode: "MS",
    countryName: "USA",
},
{
    stateId: "MT,USA",
    stateName: "Montana",
    stateCode: "MT",
    countryName: "USA",
},
{
    stateId: "MP,USA",
    stateName: "Northern Mariana Islands",
    stateCode: "MP",
    countryName: "USA",
},
{
    stateId: "NC,USA",
    stateName: "North Carolina",
    stateCode: "NC",
    countryName: "USA",
},
{
    stateId: "ND,USA",
    stateName: "North Dakota",
    stateCode: "ND",
    countryName: "USA",
},
{
    stateId: "NE,USA",
    stateName: "Nebraska",
    stateCode: "NE",
    countryName: "USA",
},
{
    stateId: "NV,USA",
    stateName: "Nevada",
    stateCode: "NV",
    countryName: "USA",
},
{
    stateId: "NH,USA",
    stateName: "New Hampshire",
    stateCode: "NH",
    countryName: "USA",
},
{
    stateId: "NJ,USA",
    stateName: "New Jersey",
    stateCode: "NJ",
    countryName: "USA",
},
{
    stateId: "NM,USA",
    stateName: "New Mexico",
    stateCode: "NM",
    countryName: "USA",
},
{
    stateId: "NY,USA",
    stateName: "New York",
    stateCode: "NY",
    countryName: "USA",
},
{
    stateId: "OH,USA",
    stateName: "Ohio",
    stateCode: "OH",
    countryName: "USA",
},
{
    stateId: "OK,USA",
    stateName: "Oklahoma",
    stateCode: "OK",
    countryName: "USA",
},
{
    stateId: "OR,USA",
    stateName: "Oregon",
    stateCode: "OR",
    countryName: "USA",
},
{
    stateId: "PA,USA",
    stateName: "Pennsylvania",
    stateCode: "PA",
    countryName: "USA",
},
{
    stateId: "RI,USA",
    stateName: "Rhode Island",
    stateCode: "RI",
    countryName: "USA",
},
{
    stateId: "SC,USA",
    stateName: "South Carolina",
    stateCode: "SC",
    countryName: "USA",
},
{
    stateId: "SD,USA",
    stateName: "South Dakota",
    stateCode: "SD",
    countryName: "USA",
},
{
    stateId: "TN,USA",
    stateName: "Tennessee",
    stateCode: "TN",
    countryName: "USA",
},
{
    stateId: "TX,USA",
    stateName: "Texas",
    stateCode: "TX",
    countryName: "USA",
},
{
    stateId: "UT,USA",
    stateName: "Utah",
    stateCode: "UT",
    countryName: "USA",
},
{
    stateId: "VA,USA",
    stateName: "Virginia",
    stateCode: "VA",
    countryName: "USA",
},
{
    stateId: "VT,USA",
    stateName: "Vermont",
    stateCode: "VT",
    countryName: "USA",
},
{
    stateId: "WA,USA",
    stateName: "Washington",
    stateCode: "WA",
    countryName: "USA",
},
{
    stateId: "WV,USA",
    stateName: "West Virginia",
    stateCode: "WV",
    countryName: "USA",
},
{
    stateId: "WI,USA",
    stateName: "Wisconsin",
    stateCode: "WI",
    countryName: "USA",
},
{
    stateId: "WY,USA",
    stateName: "Wyoming",
    stateCode: "WY",
    countryName: "USA",
}
]
export default ungroupedData